// Campus photo for /colleges/swarthmore-college: Public domain, by Ugen64 at English Wikipedia, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AParrish_Hall_(cropped).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/swarthmore-college/; credited under the photo.
const photo = {
    "slug": "swarthmore-college",
    "alt": "Parrish Hall seen across the lawn on a spring day at Swarthmore College in Swarthmore, Pennsylvania",
    "src": "/colleges/swarthmore-college/campus-1600.webp",
    "srcSmall": "/colleges/swarthmore-college/campus-800.webp",
    "srcMid": "/colleges/swarthmore-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/swarthmore-college/og.jpg",
    "title": "Parrish Hall (cropped)",
    "author": "Ugen64 at English Wikipedia",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AParrish_Hall_(cropped).jpg",
    "read": "2026-10-01"
};

export default photo;
